import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

const DashboardError = ({ error, onRetry }) => {
  return (
    <motion.div
      className="flex flex-col items-center justify-center min-h-[calc(100vh-200px)] text-center p-4 bg-destructive/10 border border-destructive rounded-lg shadow-lg"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <AlertTriangle className="h-16 w-16 text-destructive mb-6" />
      <h2 className="text-3xl font-semibold text-destructive mb-2">Oops! Something went wrong.</h2>
      <p className="text-lg text-destructive/80 mb-4">
        We encountered an error while trying to load your dashboard data.
      </p>
      <p className="text-sm text-muted-foreground bg-destructive/5 p-3 rounded-md mb-6 max-w-md">
        <strong>Error details:</strong> {typeof error === 'string' ? error : (error?.message || 'An unknown error occurred.')}
      </p>
      {onRetry && (
        <Button onClick={onRetry} variant="destructive" size="lg">
          <RefreshCw className="mr-2 h-4 w-4" /> Try Again
        </Button>
      )}
      <p className="mt-6 text-sm text-muted-foreground">
        If the problem persists, please contact support.
      </p>
    </motion.div>
  );
};

export default DashboardError;